// List of roles with their given name in the database, if need to add more add them here and update the router to include them
const Roles = Object.freeze({
  ADMIN: 'Administrator',

  // GRAYSTONE_ADMIN: 'GraystoneAdministrator',
  GRAYSTONE_DATA_ENTRY: 'GraystoneDataEntry',
  GRAYSTONE_SALES: 'GraystoneSales',

  // CLIENT_ADMIN: 'ClientAdministrator',
  CLIENT_PERSONNEL: 'ClientPersonnel',
});

export default Roles;
